export default __webpack_public_path__ + "fff22708511eaa6b72762eb92924f323.png";